module.exports = __webpack_public_path__ + "static/media/sloga-slider-desktop.dfc40010.png";